<template>
  <e-sidebar
    :show="visible"
    :title="isEditing ? $t('Editar Estoque Mínimo') : $t('Adicionar Estoque Mínimo')"
    width="500px"
    @save="save"
    @hidden="visible = false"
  >
    <template #content>
      <FormulateForm 
        ref="form" 
        @submit="save"
      >
        <b-row>
          <b-col 
            md="12" 
            class="mb-2"
          >
            <e-store-combo
              v-model="form.storeId"
              :required="false"
              :only-active-options="true"
              :label="$t('Loja')"
              :placeholder="$t('Geral')"
            />
          </b-col>
          <b-col 
            md="12" 
            class="mb-2"
          >
            <FormulateInput
              id="minimum-stock"
              v-model.number="form.minimumStock"
              type="number"
              :label="$t('Estoque Mínimo')"
              validation="required|min:0"
            />
          </b-col>
        </b-row>
      </FormulateForm>
    </template>
  </e-sidebar>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { ESidebar, EStoreCombo } from '@/views/components'

export default {
  name: 'ConfigurationSidebar',
  components: { ESidebar, EStoreCombo, BRow, BCol },
  data() {
    return {
      visible: false,
      isEditing: false,
      form: {
        storeId: null,
        minimumStock: 0,
      },
    }
  },
  methods: {
    show(item) {
      this.visible = true
      if (item) {
        // Modo edição
        this.isEditing = true
        this.form = { 
          id: item.id,
          storeId: item.storeId?.toString(),
          minimumStock: item.minimumStock || 0 
        }
      } else {
        // Modo criação
        this.isEditing = false
        this.form = { storeId: null, minimumStock: 0 }
      }
    },
    save() {
      if (this.isEditing) {
        this.$emit('update', { ...this.form })
      } else {
        this.$emit('create', { ...this.form })
      }
      this.visible = false
    },
  },
}
</script>

<style scoped></style>
